import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as deliveryAction from '../../../../actions/deliveryAction';
import * as actionsLinePicking from '../../../../actions/linePickingAction';
import * as actionsPicking from '../../../../actions/pickingAction';
import { TitleUI } from '../../../../components/UI/LabelTitleUI';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import JustificationService from '../../../../services/JustificationService';
import LinePickingService from '../../../../services/LinePickingService';
import { checkPermission, getVision } from '../../../../services/auth';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../utils/constants';
import { getPathApp, translate } from '../../../../utils/util';

const LinePicking = (props) => {
    useEffect(() => {
        if (!props.justifications?.items || props.justifications?.items?.length === 0) {
            props.getJustifications(props.user.vision, {});
        }
        // eslint-disable-next-line
    }, []);

    const menu = () => {
        let menuItems = [];

        if (checkPermission(PERMISSIONS.LinePicking.SmallParts.Access)) {
            menuItems = [...menuItems, { route: 'linePicking/parameters', icon: 'mdi mdi-camera-timer', text: translate('line-picking:linepicking:title') }];
        }

        if (checkPermission(PERMISSIONS.Delivery.Access) && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            menuItems = [...menuItems, { route: `${getPathApp(window)}/delivery`, icon: 'mdi mdi-cart-check', text: translate('menu:delivery') }];
        }

        if (checkPermission(PERMISSIONS.LinePicking.SmallParts.Route)) {
            menuItems = [...menuItems, {
                route: {
                    pathname: 'routePicking',
                    state: {
                        routeType: ENUMS.eRouteType.LinePicking.value

                    }
                }, icon: "mdi mdi-map-marker-path", text: translate('route', 'route-picking')
            }];
        }

        if (checkPermission(PERMISSIONS.LinePicking.SmallParts.Cart) && getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            menuItems = [...menuItems, { route: 'qrCode', icon: "mdi mdi-qrcode", text: translate('qrcode', 'qrcode-picking') }];
        }

        if (checkPermission(PERMISSIONS.LinePicking.SmallParts.ManageLinePicking)) {
            menuItems = [...menuItems, {
                route: {
                    pathname: 'linePicking/transmissions',
                    state: { type: ENUMS.eOrderType.LinePicking.value }
                },
                icon: "mdi mdi-clipboard-list-outline",
                text: translate('expedition:picking.transmissions')
            }];

            menuItems = [...menuItems, {
                route: {
                    pathname: 'linePicking/report',
                    state: { orderType: ENUMS.eOrderType.LinePicking.value }
                },
                icon: 'mdi mdi-clipboard-list-outline',
                text: translate('line-picking:linepicking.report')
            }];

            menuItems = [...menuItems, {
                route: 'expedition/logGcp',
                icon: 'mdi mdi-file-alert-outline',
                text: translate('log-gcp', 'expedition:picking')
            }];

            if (getVision() !== VISIONS.Jeep) {
                menuItems = [...menuItems, {
                    route: {
                        pathname: 'report'
                    },
                    icon: 'mdi mdi-clipboard-list-outline',
                    text: translate('line-picking:linepicking.fileReport')
                }];

                menuItems = [...menuItems, {
                    route: {
                        pathname: 'uploadCalls',
                        state: { orderType: ENUMS.eOrderType.LinePicking.value }
                    },
                    icon: "mdi mdi-clipboard-check-outline",
                    text: translate('line-picking:uploadCalls:uploadFile')
                }];

                menuItems = [...menuItems,
                {
                    onClick: () => {
                        props.setFilterManualCall({});
                    },
                    route: `${getPathApp(window)}/delivery/manualCall`,
                    icon: 'mdi mdi-gesture-tap-hold', text: translate('delivery:general.manualOrder')
                }];
            }

            if (checkPermission(PERMISSIONS.LinePicking.ManualCallPdu)) {
                menuItems = [...menuItems, {
                    route: 'delivery/qrCodeCall/home',
                    icon: "mdi mdi-qrcode",
                    text: translate('picking.qrCodeCall', 'expedition')
                }];

                menuItems = [...menuItems, {
                    route: {
                        pathname: 'delivery/qrcodeCall',
                        state: { manualCallPdu: true }
                    },
                    icon: "mdi mdi-qrcode",
                    text: `${translate('qrcode-call', 'delivery')}`
                }];
            }

            if (checkPermission(PERMISSIONS.LinePicking.ManualCallMapping)) {
                menuItems = [...menuItems, {
                    route: {
                        pathname: 'delivery/qrcodeCall',
                        state: { manualCallMapping: true }
                    },
                    icon: "mdi mdi-qrcode",
                    text: `${translate('qrcode-call', 'delivery')} ${translate('mapping:title', 'line-picking')}`
                }];
            }

            if (getVision() === VISIONS.Faasa) {
                menuItems = [...menuItems, {
                    route: {
                        pathname: 'linePicking/tdwriteoff'
                    },
                    icon: 'mdi mdi-archive-check-outline',
                    text: translate('expedition:picking.tdWriteOff')
                }];

                menuItems = [...menuItems, {
                    onClick: () => {
                        props.clearOrders();
                    },
                    route: {
                        pathname: 'linePicking/tdreport'
                    },
                    icon: 'mdi mdi-archive-search-outline',
                    text: translate('expedition:picking.tdReport')
                }];

                menuItems = [...menuItems, {
                    route: {
                        pathname: 'linePicking/tdopen'
                    },
                    icon: 'mdi mdi-archive-clock-outline',
                    text: translate('expedition:picking.openTds')
                }];
            }

            menuItems = [...menuItems, {
                route: 'linePicking/smallParts/print/identification',
                icon: 'filter_frames',
                text: translate('identification-label', 'physical-confirmation')
            }];

            if (getVision() === VISIONS.Fiasa) {
                menuItems = [...menuItems, {
                    route: 'linePicking/outside',
                    icon: 'filter_frames',
                    text: "Peça Fora"
                }];
            }

            if (checkPermission(PERMISSIONS.LinePicking.Mapping.Access)) {
                menuItems = [...menuItems, {
                    route: 'linePicking/mapping',
                    icon: 'mdi mdi-grid',
                    text: translate('mapping:title', 'line-picking')
                }];
            }

            menuItems = [...menuItems, {
                route: {
                    pathname: 'endCalls',
                    state: { orderType: ENUMS.eOrderType.LinePicking.value }
                },
                icon: "mdi mdi-close-network-outline",
                text: translate('line-picking:endCalls:end-calls-logistics')
            }];
        }
        if (checkPermission(PERMISSIONS.LinePicking.Mapping.QuantityAligment)) {
            menuItems = [...menuItems, {
                route: {
                    pathname: 'linePicking/mapping/list',
                    state: { quantityAlignment: true }

                },
                icon: 'mdi mdi-chart-line', text: "Alinhamento de Quantidade"
            }];
        }

        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-timetable" label={translate('menu.line-picking', 'configuration')} />
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications,
        filter: state.linePickingReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        },
        disconnectMq: (Callback) => {
            dispatch(LinePickingService.disconnectMq(Callback));
        },
        connectMq: (Callback) => {
            dispatch(LinePickingService.connectMq(Callback));
        },
        setFilterOrder: (filter) => {
            dispatch(actionsLinePicking.setFilter(filter));
        },
        clearOrders: () => {
            dispatch(actionsPicking.resetOrder());
            dispatch(actionsPicking.resetOrders());
        },
        setFilterManualCall: (filter) => {
            dispatch(deliveryAction.setFilterManualCall(filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LinePicking)));